require('./OKMultipleSelect.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const Select = require('react-select').default;
const classnames = require('classnames');

// @ components
const OKTooltip = require('../OKTooltip/OKTooltip');

const getValueWidth = (valueWidth, value) => {
    return (valueWidth - parseFloat(window.getComputedStyle(value).marginLeft,10) - parseFloat(window.getComputedStyle(value).marginRight,10)) + "px";
}

class OKMultipleSelect extends React.Component {

    constructor(props) {
        super(props);

        this.customOption = this.customOption.bind(this);
        this.renderValue = this.renderValue.bind(this);
        this.handleCloseMenu = this.handleCloseMenu.bind(this);
        this.handleOpenMenu = this.handleOpenMenu.bind(this);
        this.formatWrapper = this.formatWrapper.bind(this);
        this.state = {
            openUp: false
        };
    }

    componentDidMount() {
        this.formatWrapper();
    }

    componentDidUpdate() {
        this.formatWrapper();
    }

    handleCloseMenu() {
        this.setState({
            openUp: false
        });
    }

    handleOpenMenu() {
        this.setState({
            openUp: true
        });
    }

    getClassNames() {
        const { errorState } = this.props;

        return classnames('ok-multiple-select', {
            'ok-multiple-select--opened': !!this.state.openUp,
            'ok-multiple-select--closed': !this.state.openUp,
            'ok-multiple-select--error': errorState
        });
    }

    // Adding icons and text to select component
    customOption(option) {
        let icon;

        if (option.icon) {
            icon = <i className={option.icon}></i>;
        }

        return(
            <div className="ok-multiple-select__option-icon">
                {icon}
                <span>{option.label}</span>
            </div>
        )
    }

    // Adding icons and text to select component (selected value)
    renderValue(option) {
        let icon;

        if (option.icon) {
            icon = <i className={option.icon}></i>;
        }

        return(
            <div className="ok-multiple-select__value-icon">
                {icon}
                <span>{option.label}</span>
            </div>
        )
    }

    formatWrapper() {
        if (!this.props.id) {
            return;
        }
        if (!document.getElementById(this.props.id)) {
            return;
        }
        if (!document.getElementById(this.props.id).getElementsByClassName('Select-control')) {
            return;
        }

        const wrapper = document.getElementById(this.props.id).getElementsByClassName('Select-multi-value-wrapper')[0];
        const values = document.getElementById(this.props.id).getElementsByClassName('Select-value');

        wrapper.className = 'Select-multi-value-wrapper';
        for (let value of values) {
            value.style.width = 'auto';
            value.style.display = "inline-block";
        }

        if (!this.state.openUp) {
            const select = document.getElementById(this.props.id);
            //const arrow = document.getElementById(this.props.id).getElementsByClassName('Select-arrow-zone')[0];
            const arrowWidth = 25;//parseInt(window.getComputedStyle(arrow).width, 10);
            const counterWidth = 25;
            const computedWrapperWidth = parseInt(window.getComputedStyle(wrapper).width, 10);
            const minimunWrapperWidth = parseInt(window.getComputedStyle(select).width, 10) - arrowWidth; // Arrow
            const minimunWrapperCountedWidth = minimunWrapperWidth - counterWidth; // Arrow
            const minimunValueWidth = 90;

            // if the computed wrapper width is bigger than multiple select width
            if (computedWrapperWidth > minimunWrapperWidth) {

                const minimunReadableWrapperWidth = values.length * minimunValueWidth;

                // if the minimun readable wrapper width is bigger than select width
                // overflow a minimun has posible all values that you can and the rest hide them and sumarize it
                if (minimunReadableWrapperWidth > minimunWrapperWidth) {
                    const numValuesToShow = parseInt(minimunWrapperCountedWidth/minimunValueWidth);
                    const newValueProportionWidth = parseInt(minimunWrapperCountedWidth/numValuesToShow);

                    for (let i=0; i < numValuesToShow; i++) {
                        values[i].style.width = getValueWidth(newValueProportionWidth, values[i]);
                    }
                    for (let i=numValuesToShow; i < values.length; i++) {
                        values[i].style.display = 'none';
                    }
                    wrapper.className = 'Select-multi-value-wrapper Select-multi-value-wrapper--overflowed--counting Select-multi-value-wrapper--overflowed--counting--' + (values.length - numValuesToShow);
                }
                // if the minimun readable wrapper width is lower than select width
                // so with a simple overflow and resize should be fine
                else {
                    const newValueProportionWidth = parseInt(minimunWrapperWidth / values.length);
                    for (let value of values) {
                        value.style.width = getValueWidth(newValueProportionWidth, value);
                    }
                    wrapper.className = 'Select-multi-value-wrapper Select-multi-value-wrapper--overflowed'
                }
            }
        }
    }

    render() {
        const {
            disabled,
            errorMessage,
            errorState,
            label,
            optionalElement,
            placeholder,
            showLabel,
            tooltipContent,
            tooltipOffset,
            tooltipPlacement,
            tooltipTitle,
            clearable,
        } = this.props;
        const className = this.getClassNames();
        const labelClass = showLabel ? 'ok-multiple-select__label' : 'ok-multiple-select__label-invisible';
        let labelElement; 
        let elementMessage; 
        let tooltipElement;
        let optionalElementContent;

        if (errorState) {
            elementMessage = (
                <div className="ok-multiple-select__error-msg">
                    {errorMessage}
                </div>
            );
        }

        if (!!label) {
            if (!!tooltipContent) {
                let tooltipType;

                if(!!tooltipTitle) {
                    tooltipType = 'explicative';
                }
                tooltipElement = (
                    <OKTooltip
                        content={tooltipContent}
                        offset={tooltipOffset}
                        placement={tooltipPlacement}
                        title={tooltipTitle}
                        type={tooltipType}
                    />
                );
            }

            labelElement = (
                <label className={labelClass}>
                    {label}
                </label>
            );
        }

        if (optionalElement) {
            optionalElementContent = (
                <span className="ok-multiple-select__optional-element">
                    {optionalElement}
                </span>
            );
        }        

        return (
            <div className={className} id={this.props.id}>
                {labelElement}
                {tooltipElement}
                {optionalElementContent}
                <Select
                    {...this.props}
                    arrowRenderer={() => (<i className="ok-multiple-select__arrow icon-dropdown-abrir" />)}
                    clearable={clearable}
                    disabled={disabled}
                    optionRenderer={this.customOption}
                    placeholder={placeholder}
                    valueRenderer={this.renderValue}
                    onClose={this.handleCloseMenu}
                    onOpen={this.handleOpenMenu}
                />
                {elementMessage}
            </div>
        )
    }
}

OKMultipleSelect.propTypes = {
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    errorState: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    noResultsText: PropTypes.string,
    onChange: PropTypes.func,
    openOnFocus: PropTypes.bool,
    optionalElement: PropTypes.object,
    options: PropTypes.array,
    overflowed: PropTypes.bool,
    placeholder: PropTypes.string,
    showLabel: PropTypes.bool,
    tooltipContent: PropTypes.any,
    tooltipOffset: PropTypes.array,
    tooltipPlacement: PropTypes.string,
    tooltipTitle: PropTypes.string,
    value: PropTypes.array
};

OKMultipleSelect.defaultProps = {
    clearAllText: false,
    clearable: false,
    closeOnSelect: false,
    disabled: false,
    multi: true,
    overflowed: false,
    removeSelected: false,
    searchable: false,
    showLabel: true    
};

module.exports = OKMultipleSelect;
